import { Box, Chip, Paper, Typography } from "@mui/material";
import PhotoUploadCrop from "components/File/PhotoUploadCrop";
import React from "react";

function EmployeeHeader(props) {
    const { form, updateField, person, isNew, renderActions } = props;

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                <PhotoUploadCrop
                    value={form?.PhotoFileName}
                    sourceImage={isNew ? null : form?.photoFileName}
                    onUploadSuccess={(result) => {
                        updateField(
                            "PhotoFileName",
                            result?.fileName ?? result?.path
                        );
                    }}
                    // label="Profile Photo"
                />
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5
                        }}
                    >
                        <Typography variant="h5" fontWeight="bold">
                            {person?.fullName ||
                                (isNew ? "New Employee" : "Loading...")}
                        </Typography>
                        {person?.employeeCode && (
                            <Chip
                                label={person.employeeCode}
                                size="small"
                                variant="outlined"
                            />
                        )}
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                        {person?.position || "Employee Profile"}
                    </Typography>
                </Box>
            </Box>

            {/* Header Action Buttons */}
            {renderActions()}
        </Paper>
    );
}

export default EmployeeHeader;
